export const disabled = "var(--seed-color-bg-disabled)";
export const overlay = "var(--seed-color-bg-overlay)";
export const brandSolid = "var(--seed-color-bg-brand-solid)";
export const brandSolidPressed = "var(--seed-color-bg-brand-solid-pressed)";
export const criticalSolid = "var(--seed-color-bg-critical-solid)";
export const criticalWeak = "var(--seed-color-bg-critical-weak)";
export const criticalSolidPressed = "var(--seed-color-bg-critical-solid-pressed)";
export const criticalWeakPressed = "var(--seed-color-bg-critical-weak-pressed)";
export const informativeSolid = "var(--seed-color-bg-informative-solid)";
export const informativeWeak = "var(--seed-color-bg-informative-weak)";
export const informativeSolidPressed = "var(--seed-color-bg-informative-solid-pressed)";
export const informativeWeakPressed = "var(--seed-color-bg-informative-weak-pressed)";
export const layerBasement = "var(--seed-color-bg-layer-basement)";
export const layerDefault = "var(--seed-color-bg-layer-default)";
export const layerFill = "var(--seed-color-bg-layer-fill)";
export const layerFloating = "var(--seed-color-bg-layer-floating)";
export const layerDefaultPressed = "var(--seed-color-bg-layer-default-pressed)";
export const layerFloatingPressed = "var(--seed-color-bg-layer-floating-pressed)";
export const magicSolid = "var(--seed-color-bg-magic-solid)";
export const magicWeak = "var(--seed-color-bg-magic-weak)";
export const magicSolidPressed = "var(--seed-color-bg-magic-solid-pressed)";
export const magicWeakPressed = "var(--seed-color-bg-magic-weak-pressed)";
export const neutralInverted = "var(--seed-color-bg-neutral-inverted)";
export const neutralSolid = "var(--seed-color-bg-neutral-solid)";
export const neutralWeak = "var(--seed-color-bg-neutral-weak)";
export const neutralInvertedPressed = "var(--seed-color-bg-neutral-inverted-pressed)";
export const neutralSolidMuted = "var(--seed-color-bg-neutral-solid-muted)";
export const neutralSolidMutedPressed = "var(--seed-color-bg-neutral-solid-muted-pressed)";
export const neutralWeakPressed = "var(--seed-color-bg-neutral-weak-pressed)";
export const overlayMuted = "var(--seed-color-bg-overlay-muted)";
export const positiveSolid = "var(--seed-color-bg-positive-solid)";
export const positiveWeak = "var(--seed-color-bg-positive-weak)";
export const positiveSolidPressed = "var(--seed-color-bg-positive-solid-pressed)";
export const positiveWeakPressed = "var(--seed-color-bg-positive-weak-pressed)";
export const warningSolid = "var(--seed-color-bg-warning-solid)";
export const warningWeak = "var(--seed-color-bg-warning-weak)";
export const warningWeakPressed = "var(--seed-color-bg-warning-weak-pressed)";